import { Box, ClickAwayListener, ListItemButton, ListItemIcon, ListItemText, Paper, Popper } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'

export default function StatusMenu({ anchorEl, setStatus, close }: any) {

    return (
        <Popper id={"energySavingsModeMenu"} 
            open={Boolean(anchorEl)} anchorEl={anchorEl}  >
            <ClickAwayListener onClickAway={()=>close(null)}>
            <Paper sx={{ 
                    borderRadius: custom.corners3, 
                    py: custom.spacing.xxs, 
                    pr: custom.spacing.xxs 
                }} elevation={10}>
                <ListItemButton id="energySavingsModeEnabled"
                    onClick={()=>{setStatus('Enabled')}} sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'sz.colors.hover',
                      boxShadow: 'none',
                    },
                }}>
                <ListItemIcon>
                    <Box
                        component={'img'}
                        height="auto"
                        width="25px"
                        loading="lazy"
                        alt="Hot water status"
                        src={`/images/EnergySavingEnabled.svg`}
                    />
                </ListItemIcon>
                <ListItemText primary="Enabled" 
                    primaryTypographyProps={{ 
                        variant: 'szHeading.Regular.xxSmall', 
                        ml:-3
                    }} />
                </ListItemButton>
                <ListItemButton id="energySavingsModePaused"
                    onClick={()=>{setStatus('Paused')}} sx={{
                        cursor: 'pointer',
                        '&:hover': {
                        backgroundColor: 'sz.colors.hover',
                        boxShadow: 'none',
                        },
                    }}>
                <ListItemIcon>
                    <Box
                        component={'img'}
                        height="auto"
                        width="25px"
                        loading="lazy"
                        alt="Hot water status"
                        src={`/images/EnergySavingPaused.svg`}
                    />
                </ListItemIcon>
                <ListItemText primary="Pause until tomorrow"
                    primaryTypographyProps={{ 
                        variant: 'szHeading.Regular.xxSmall', 
                        ml:-3
                    }} />
                </ListItemButton>
                <ListItemButton id="energySavingsModeDisabled"
                    onClick={()=>{setStatus('Disabled')}} 
                        sx={{
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: 'sz.colors.hover',
                                boxShadow: 'none',
                            },
                        }}>
                <ListItemIcon>
                    <Box
                        component={'img'}
                        height="auto"
                        width="25px"
                        loading="lazy"
                        alt="Hot water status"
                        src={`/images/EnergySavingDisabled.svg`}
                    />
                </ListItemIcon>
                <ListItemText primary="Disabled" 
                    primaryTypographyProps={{ 
                        variant: 'szHeading.Regular.xxSmall', 
                        ml:-3
                    }} />
                </ListItemButton>
            </Paper>
            </ClickAwayListener>
        </Popper>
    )
}

